/**
 * @file サポーターを団に登録する画面で必要なデータをフェッチ
 *
 */
'use strict'

/**
 * @classname RegisterSupporter
 * @classdesc サポーターを団に登録する画面で必要なデータをフェッチ
 */
export default class RegisterSupporter {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#form-register-supporter')
	 */
	constructor($e, controller) {
		console.log('RegisterSupporter.constructor')
		this._$e = $e
		this._controller = controller
		this.registerSupporter()
		this._controller.on('registerSupporterComplete', () => this.registerSupporterComplete())
	}


	/**
	 * サポーターを団に登録する画面で必要なデータをフェッチ
	 *
	 * @memberof RegisterSupporter
	 * @return {undefined}
	 */
	registerSupporter() {
		console.log('RegisterSupporter.registerSupporter')
		this._controller.registerSupporter(this._$e.data('group-id'))
	}


	/**
	 * サポーターを団に登録する画面で必要なデータをフェッチ
	 *
	 * @memberof RegisterSupporter
	 * @return {undefined}
	 */
	registerSupporterComplete() {
		console.log('RegisterSupporter.registerSupporterComplete')
		console.log(this._controller._registerSupporterData)
	}
}
